/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {GenericModelViewerListNode} from "../../../Components/Common/GenericModelViewerListNode";
import {MutableList} from "../../../Components/Common/MutableList";
import React from "react";

export class ChildrenFieldViewer extends BaseFieldViewer {
	@autobind
	getPKName() {
		let model = this.props.FieldDef.association.model;
		let pk = model.getPrimaryKeyName();
		return pk;
	}

	@autobind
	_render() {
		let list = {
			component: MutableList
		};
		if (this.props.FieldDef.association.listComponentOverride) {
			list.component = this.props.FieldDef.association.listComponentOverride;
		}
		return <list.component
			Editable={false}
			DataTypeName={this.props.FieldDef.title}
			Data={this.props.Value}
			Type={GenericModelViewerListNode}
			AdditionalTypeProps={{
				RootData: this.props.RootData,
				FieldDef: this.props.FieldDef,
				Editable: false,
				CustomData: {...this.props.CustomData, ...this.props.FieldDef.association.customData},
				OnValidationUpdate: this.props.OnValidationUpdate
			}}
			GetDraggableId={(x) => {
				let pk = this.getPKName();
				return pk + ":" + (x[pk] || x._tempId);
			}}
			GetItemKey={(x) => this.props.Value.indexOf(x)}
			GetSortKey={() => {
				return this.props.FieldDef.association.sortKey ?? this.props.FieldDef.association.orderable;
			}}
			//INFO: These methods don't need to be defined since this will never be editable.
			UpdateItems={() => {
			}}
			UpdateItem={() => {
			}}
			AddItem={() => {
			}}
			RemoveItem={() => {
			}}
		>{this.props.children}</list.component>;
	}
}